// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Grid, Container, Stack, Typography, Pagination, TextField, Button, Card, CardContent } from '@mui/material';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Page from '../components/Page';
import { SpacePostCardVendor } from '../sections/@dashboard/revenue';
import { SpacePostSearchByName } from '../sections/@dashboard/parkings';
import { useGetRevenueDataMutation } from '../store/api/revenueApi';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setRevenue, getVendorRevenue, getRevenueTotalPages } from '../store/state/revenueSlice';
import Loading from '../components/Loading';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Formik } from 'formik';
import { getEndDate, getStartDate, GET_REVENUE_TABDATA } from '../sections/@dashboard/parkingspaces/utility';
import { styled } from '@mui/material/styles';
import toast from 'react-hot-toast';

let day1 = new Date();
let day7 = new Date(day1.getFullYear(), day1.getMonth(), day1.getDate() - 7);
day7 = day7.toISOString();
let day30 = new Date(day1.getFullYear(), day1.getMonth(), day1.getDate() - 30);
day30 = day30.toISOString();
let newDay = [day1, day7, day30];

export default function Revenue() {
  const dispatch = useAppDispatch();
  const [revenues, setRevenues] = useState([]);
  const token = JSON.parse(localStorage.getItem('login') || '{}');
  const [getRevenueData, revenueResponse] = useGetRevenueDataMutation();
  const revenueData = useAppSelector(getVendorRevenue);
  const totalPages = useAppSelector(getRevenueTotalPages);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [getDay, setGetDay] = useState();
  const [endDay, setEndDay] = useState();
  const [value, setValue] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const isUserNotFound = revenues[0]?.parkingSpaceRevenueDataList.length === 0;
  const [initialValues, setInitialValues] = useState({
    fromDates: '',
    toDates: '',
  });
  const parkingsPerPage = 5;

  let currentDay = new Date();
  currentDay = currentDay.toISOString();

  let revenueList: any = revenues[0]?.parkingSpaceRevenueDataList ? revenues[0]?.parkingSpaceRevenueDataList : revenues;
  const isRevenueNotAvailable = revenues.length === 0;
  useEffect(() => {
    getRevenueData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[value]),
        toDate: getEndDate(GET_REVENUE_TABDATA[value]),
        serviceProviderId: token.serviceProviderId,
        isDisputed: false,
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
  }, [getRevenueData]);

  const getRevenueDataAsync = async (page, parkingPerPage, searchTerm = '') => {
    await getRevenueData({
      token: token.token,
      payload: {
        page: page,
        offset: parkingPerPage,
        fromDate: getStartDate(GET_REVENUE_TABDATA[value]),
        toDate: getEndDate(GET_REVENUE_TABDATA[value]),
        serviceProviderId: token.serviceProviderId,
        searchValue: searchTerm,
        isDisputed: false,
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
  };

  useEffect(() => {
    if (revenueResponse.isSuccess) {
      dispatch(setRevenue(revenueResponse.data.revenueData));
      if (revenueResponse.data?.totalRecords == 0) {
        toast.success('No data available');
      }
    }
  }, [revenueResponse.isSuccess]);

  useEffect(() => {
    if (revenueData) {
      setRevenues(revenueData);
    }
  }, [revenueData]);

  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

  const handlePagination = (pages: number) => {
    setPage(pages - 1);
    getRevenueDataAsync(pages - 1, rowsPerPage);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setGetDay(getStartDate(GET_REVENUE_TABDATA[newValue]));
    setEndDay(getEndDate(GET_REVENUE_TABDATA[newValue]));
    getRevenueData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[newValue]),
        toDate: getEndDate(GET_REVENUE_TABDATA[newValue]),
        serviceProviderId: token.serviceProviderId,
        isDisputed: false,
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
  };

  const handleSearchTerm = (event) => {
    setPage(0);
    setSearchTerm(event.target.value);
    getRevenueDataAsync(page, parkingsPerPage, event.target.value);
  };

  const handelDatePicker = (values: any) => {
    getRevenueData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getDay === undefined ? getStartDate(GET_REVENUE_TABDATA[0]) : getDay,
        toDate: endDay === undefined ? getEndDate(GET_REVENUE_TABDATA[0]) : endDay,
        serviceProviderId: token.serviceProviderId,
        isDisputed: false,
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
  };

  return (
    <Page title="Revenue Overview">
      <Container>
        <Typography variant="h4" mb={3}>
          Revenue Overview
        </Typography>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={3} style={{ width: '100%' }}>
            <Tabs value={value} onChange={handleChange} aria-label="nav tabs example">
              <LinkTab label="Today" />
              <LinkTab label="This Week" />
              <LinkTab label="This Month" />
            </Tabs>
          </Stack>
        </Box>
        <Stack mb={5} direction="row" alignItems="center" justifyContent="space-between" className="search">
          <SpacePostSearchByName
            value={searchTerm}
            handleSearchTerm={handleSearchTerm}
            posts={revenueList}
            placeholder={'Search Car Name'}
          />
          <Formik enableReinitialize initialValues={initialValues} onSubmit={handelDatePicker}>
            {({ handleBlur, handleChange, handleSubmit, setFieldValue, values }) => (
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginLeft: '30px',
                }}
                className="datepicker"
              >
                {' '}
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="From Date"
                    value={getDay}
                    onChange={(event: any) => {
                      setGetDay(event);
                    }}
                    renderInput={(params) => (
                      <TextField
                        id="fromDates"
                        name="fromDates"
                        style={{
                          width: '35%',
                          borderColor: 'blue',
                        }}
                        className="datepickerone"
                        onBlur={handleBlur}
                        onChange={(event: any) => {
                          setGetDay(event.target.value);
                        }}
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="To Date"
                    value={endDay}
                    onChange={(event: any) => {
                      setEndDay(event);
                    }}
                    renderInput={(params) => (
                      <TextField
                        id="toDates"
                        name="toDates"
                        style={{
                          width: '35%',
                          borderColor: 'blue',
                        }}
                        className="datepickertwo"
                        onBlur={handleBlur}
                        onChange={(event: any) => {
                          setEndDay(event.target.value);
                        }}
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
                <Stack>
                  <Button
                    style={{
                      width: '100%',
                      borderColor: 'blue',
                      padding: '10px',
                      marginLeft: '10px',
                      alignItems: 'center',
                      color: 'white',
                      backgroundColor: '#E23744',
                    }}
                    className="submitbutton"
                    onClick={() => {
                      handleSubmit();
                    }}
                    variant="contained"
                  >
                    Submit
                  </Button>
                </Stack>
              </Box>
            )}
          </Formik>
        </Stack>

        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          {revenueList &&
            revenueList?.map((revenue) => (
              <SpacePostCardVendor key={revenue.id} post={revenue} value={value} index={0} />
            ))}
        </Grid>

        <Grid container spacing={3} marginBottom="20px" marginTop="20px">
          {isRevenueNotAvailable && (
            <Box display="contents" justifyContent="center" height="10px" alignItems="center">
              <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
                <Card sx={{ width: 1 }}>
                  <CardContent>
                    <Typography gutterBottom align="center" variant="subtitle1">
                      Revenue not available !!!{' '}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Box>
          )}
        </Grid>

        {!isUserNotFound && !isRevenueNotAvailable && (
          <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
            <Pagination
              count={totalPages}
              siblingCount={0}
              color={'primary'}
              size={'large'}
              onChange={handlePagination}
            />
          </Box>
        )}
      </Container>
      {revenueResponse.isLoading && <Loading />}
    </Page>
  );
}
